/**
 * DataLayer tracking for "newscientist/issue-cover" block.
 *
 * This script adds click event listeners to the issue article links and buttons within the Issue Cover
 * block to push relevant data to the dataLayer when they are clicked.
 */
const BLOCK_CLASS = '.wp-block-newscientist-issue-cover';
const ISSUES = '.issue__cover-article';
const ISSUE_LINK = '.issue__on-cover-link';
const ISSUE_EYEBROW = '.issue__cover-sub-title';
const ISSUE_BUTTONS = '.issue__on-cover > .button';
const ISSUE_BUTTON_TEXT = 'span';
const ISSUE_COVER = '.issue__cover';

const dataLayerIssueCoverInit = () => {
	const blocks = document.querySelectorAll( BLOCK_CLASS );

	blocks.forEach( block => {
		const issues = block.querySelectorAll( ISSUES );
		const issueButtons = block.querySelectorAll( ISSUE_BUTTONS );
		const issueCover = block.querySelector( ISSUE_COVER );

		issues.forEach( issue => {
			const link = issue.querySelector( ISSUE_LINK );

			if ( ! link ) {
				return;
			}

			const eyebrowLink = issue.querySelector( ISSUE_EYEBROW );

			link.addEventListener( 'click', e => {
				const eventData = {
					event: 'link_click',
					event_object_section_name: 'this-weeks-magazine',
					event_object_text: link.textContent.trim(),
					event_object_position: '1',
					event_action: 'click',
					event_object_type: 'article link',
					target_url: e.currentTarget.href,
					event_category:	eyebrowLink ? eyebrowLink.textContent.trim() : '',
				};

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( eventData );
			} );
		} );

		issueButtons.forEach( ( button, index ) => {
			button.addEventListener( 'click', event => {
				const buttonTextElement = button.querySelector( ISSUE_BUTTON_TEXT );
				const buttonText = buttonTextElement ? buttonTextElement.textContent.trim() : '';

				const eventData = {
					event: 'button_click',
					event_object_section_name: 'this-weeks-magazine',
					event_object_position: `${index + 1}`,
					event_action: 'click',
					event_object_type: 'button',
					button_text: buttonText,
					target_url: event.currentTarget.href,
				};

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( eventData );
			} );
		} );

		issueCover?.addEventListener( 'click', event => {
			const eventData = {
				event: 'link_click',
				event_object_section_name: 'this-weeks-magazine',
				event_object_position: '1',
				event_action: 'click',
				event_object_type: 'image',
				target_url: event.currentTarget.href,
			};

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push( eventData );
		} );
	} );
};

if ( document.readyState !== 'loading' ) {
	dataLayerIssueCoverInit();
} else {
	document.addEventListener( 'DOMContentLoaded', dataLayerIssueCoverInit );
}
